import React from "react";
import ExampleComponent from "../components/ExampleComponent";

const ExemplePage = () => {
  return <ExampleComponent />;
};

export default ExemplePage;
